/** Image tiers shared with the local generation service. */
export type StudioImageQuality = "standard" | "high" | "veryHigh" | "max";

export const imageQualityLabels: Record<StudioImageQuality, string> = {
  standard: "Standard",
  high: "High",
  veryHigh: "Extra high",
  max: "Max",
};

export const imageQualityOptions = Object.entries(imageQualityLabels).map(
  ([value, label]) => ({ value, label }),
);

export const normalizeImageQuality = (quality?: string): StudioImageQuality =>
  quality === "high" || quality === "veryHigh" || quality === "max"
    ? quality
    : "standard";

export type StudioImageSettings = {
  quality: StudioImageQuality;
  baseQuality: "standard" | "high" | "veryHigh";
  openaiQuality: "low" | "medium" | "high";
};

export function resolveImageSettings(
  quality: StudioImageQuality,
): StudioImageSettings {
  // Resolve the harness base tier first (including dimensions),
  // then apply openaiQuality to the image request. Never send "max" as a
  // harness tier: the existing backend would normalize it to Standard.
  // Mirrors CDK getStorySceneImageSettings: High/Very high both use medium.
  return {
    quality,
    baseQuality: quality === "max" ? "veryHigh" : quality,
    openaiQuality:
      quality === "max" ? "high" : quality === "standard" ? "low" : "medium",
  };
}

// Approved Fable token price PER IMAGE, recorded in the local ledger.
export const imageQualityCosts: Record<StudioImageQuality, number> = {
  standard: 4,
  high: 8,
  veryHigh: 12,
  max: 16,
};
